import React from "react";
import ReactDOM from 'react-dom/client';
import { useNavigate, Navigate } from 'react-router-dom';
import './App.css';
import './LandingPage.css';
import { useEffect, useState, useRef } from 'react'
import * as Auth from 'aws-amplify/auth';
import { get } from '@aws-amplify/api';
import awsconfig from './aws-exports';
import { Button, Text } from "@aws-amplify/ui-react";
import { downloadFile } from "./lib/common";
import { uploadFile } from "./lib/common";
import DatePicker from 'react-datepicker';
import { useLocation } from 'react-router-dom';
import AppLayout from './components/AppLayout';


const GenerateOptionsLegs=({ icType })=> {

  console.log("GenerateOptionsLegs : icType = " + icType);

  let email = useRef();
  let days = useRef();
  const [forceRender, setForceRender]=useState(true);
  let daysOffset =useRef();
  let security = useRef();
  let upperBound = useRef();
  let lowerBound = useRef();
  let profitAlert = useRef();
  let contracts = useRef();
  let position = useRef("Long");
  let minDepth = useRef();
  let defaultIsClicked = useRef(false);
  let optionsLegs = useRef({});
  let shortBounds = useRef({});

  const [settingsStr, setSettingsStr]=useState({"days":"","security":"","upperBound":"", "lowerBound":"", "profitAlert":"", "contracts":""});
  const [data,setData]=useState(settingsStr);
  const [error,setError]=useState('');
  let [displayMessage, setDisplayMessage] = useState("");
  const [hide, setHide]=useState("hidden");
  const [submitted, setSubmitted]=useState(false);
  const [suggest, setSuggest] = useState(false);
  let [selectedExp, setSelectedExp] = useState(null);
  const daysInputRef = useRef(null);
  const dateInputRef = useRef(null);
  const location = useLocation();
  let passedSecurity = location.state?.security || "";
  let passedSecurityCounter = useRef(0);
  console.log("GenerateOptionsLegs : passedSecurity = " + passedSecurity);

  if (passedSecurity !== "" && data.security === "" && passedSecurityCounter.current ===0) {
    console.log("GenerateOptionsLegs : passedSecurity : data = ", data);
    //passedSecurity = {"security" : passedSecurity};
    passedSecurityCounter.current++;
    security.current = passedSecurity;
    //setData(passedSecurity);
    setData((prevData) => ({
      ...prevData,
      security: passedSecurity
    }));
  }

  let initString="";

  async function listFiles() {
    await console.log("Executing listFiles");
    if (typeof(email.current) === 'undefined') {
      await getUserInfo();
    }
    //setData ( await JSON.parse(await downloadFile(email.current)));
  }

  async function getLegs() {
    console.log("Executing getLegs");
    const myAPI="mktappapi";
    let path = '/getIronCondorOptionsLegs'; 
    console.log("getLegs : data = ", data);
    
    data.profitAlert = data.profitAlert || 0;

    var passApiStr=await path + "/" + data.position.toUpperCase().trim() + "/" + data.days + "/" + data.security.toUpperCase().trim() + "/" + data.upperBound + "/" + data.lowerBound + "/" + data.profitAlert + "/" + data.contracts;
    await console.log("getLegs : passApiStr = "+ passApiStr);
    //await Promise.resolve(await get(myAPI, passApiStr))
    const response = await get({
      apiName: myAPI,
      path: passApiStr,
    }).response;
    let resp = await response.body.json();
    await Promise.resolve(resp)
      .then(async () =>{
        await console.log("getLegs : resp = " + resp);
        optionsLegs.current = await resp;
        await console.log("getLegs : optionsLegs = " + JSON.stringify(optionsLegs.current));
        setError("");
    })
    .catch(error => {
      setError(error.message);
      console.log("getLegs : Error = " + error.message);
    }) 
  }

  async function getShortBounds() {
    console.log("Executing getShortBounds");
    const myAPI="mktappapi";
    let path = '/getIronCondorShortBounds'; 
    var passApiStr=await path + "/" + data.security.toUpperCase().trim() + "/" + data.days;
    await console.log("getShortBounds : passApiStr = "+ passApiStr);
    //await Promise.resolve(await get(myAPI, passApiStr))
    const response = await get({
      apiName: myAPI,
      path: passApiStr,
    }).response;
    let resp = await response.body.json();
    await Promise.resolve(resp)
      .then(async () =>{
        await console.log("getShortBounds : resp = " + resp);
        shortBounds.current = await resp;
        await console.log("getShortBounds : shortBounds = " + JSON.stringify(shortBounds.current));

        upperBound.current = shortBounds.current.upperBound;
        lowerBound.current = shortBounds.current.lowerBound;

        setData(prevData => ({
          ...prevData,
          upperBound: shortBounds.current.upperBound,
          lowerBound: shortBounds.current.lowerBound
        }));

        setError("");
    })
    .catch(error => {
      setError(error.message);
      console.log("getShortBounds : Error = " + error.message);
    }) 
  }

  useEffect(()=>{
    
      console.log ("Executing useEffect");
      if (typeof(email.current) === 'undefined') {
        getUserInfo();
      }
      console.log("useEffect : init = "+JSON.stringify(initString));
      executeSettingsForm();
      
      console.log("useEffect : submitted = " + submitted)
      if (submitted) {
        Promise.resolve(getLegs())
        .then((resp)=>{
          console.log("useEffect : optionsLegs = " + JSON.stringify(optionsLegs.current));

          if (error === "" && Object.keys(optionsLegs.current).length !== 0) {
            navigate("/ironCondorOptionsLegs", { state: { optionsLegs: optionsLegs.current } });
          }
        })
        .catch((error)=>{
          console.log("useEffect : error = ");
          setError(error.message);
          console.log(error);
        })
      }

      if (suggest) {
        Promise.resolve(getShortBounds())
        .then((resp)=>{
          console.log("useEffect : shortBounds = " + JSON.stringify(shortBounds.current));

          if (error === "" && Object.keys(shortBounds.current).length !== 0) {
            setSuggest(false);
            //navigate("/ironCondorOptionsLegs", { state: { optionsLegs: optionsLegs.current } });
          }
        })
        .catch((error)=>{
          console.log("useEffect : error = ");
          setError(error.message);
          console.log(error);
        })
      }
      if (icType === "") {
        handleInputChange();
      }
    //}
  },[forceRender, submitted, settingsStr, data, suggest]);

  const getUserInfo = async () => {
    try {
      await Auth.fetchAuthSession();
      // Retrieve the user's email address
      const user = await Auth.fetchUserAttributes();
      console.log("getUserInfo : email = " + JSON.stringify(user.email));
      email.current = await user.email;
      return "done";
    } catch (error) {
      console.log("Error in getUserInfo: ", error);
      return "error";
    }
  };

  const navigate = useNavigate();
  console.log("Executing GenerateOptionsLegs");

  const executeSettingsForm=async ()=>{
    await getUserInfo().then(()=>{
      console.log("executeSettingsForm : data.days = "+ data.days);
      if (typeof(email.current) === 'undefined') {
        getUserInfo();
      }
      listFiles();
    })
  };

  console.log("main : settingsStr = "+JSON.stringify(settingsStr));
  console.log("main : data = "+JSON.stringify(data));
  console.log("submitted = " + submitted);
  console.log("forceRender = " + forceRender);
  if (defaultIsClicked.current) {
    //setData ({"days":"","daysOffset":"10","minDepth":"10"})
  }

  const handleSuggest = () => {
    setSuggest(true);
  }

  useEffect (()=>{
    console.log("useEffect : icType = " + icType);
    if (icType !== "") {
      days.current = 30;
      security.current = icType;
      upperBound.current = 5;
      lowerBound.current = 0.1;
      profitAlert.current = 0;
      contracts.current = 1;
      position.current = "LONG";
      if (!submitted) {
        handleSubmit();
      }
    }
  })

  const handleSubmit = ()=>{
    console.log("Executing handleSubmit");

    if (displayMessage === "") {
      setDisplayMessage("Getting IC Data ...");
    }
    
    console.log("handleSubmit : submitted = "+submitted);
    console.log("handleSubmit : days = " + days.current);
    console.log("handleSubmit : security = " + security.current);
    console.log("handleSubmit : upperBound = " + upperBound.current);
    console.log("handleSubmit : lowerBound = " + lowerBound.current);
    console.log("handleSubmit : profitAlert = " + profitAlert.current);
    console.log("handleSubmit : contracts = " + contracts.current);
    console.log("handleSubmit : position = " + position.current);
    if (!days.current || !security.current || !upperBound.current || !lowerBound.current || !contracts.current) {
      setError("Please fill in all fields");
      return;
    }

    setError('');

    setSubmitted(true);
    console.log("handleSubmit : submitted = "+submitted);
    console.log("handleSubmit : days = " + days.current);
    console.log("handleSubmit : security = " + security.current);
    console.log("handleSubmit : upperBound = " + upperBound.current);
    console.log("handleSubmit : lowerBound = " + lowerBound.current);
    console.log("handleSubmit : profitAlert = " + profitAlert.current);
    console.log("handleSubmit : contracts = " + contracts.current);
    console.log("handleSubmit : position = " + position.current);
  
    
    setData({"days":days.current,"security":security.current,"upperBound":upperBound.current, "lowerBound":lowerBound.current, "profitAlert":profitAlert.current, "position":position.current, "contracts":contracts.current, "email":email.current});
    console.log("handleSubmit - data = " + JSON.stringify(data));

  }

  function clearValues() {
    console.log("Executing clearValues")
    const clearedData = { days: "", security: "", upperBound: "", lowerBound: "", profitAlert: "", contracts: "" };
    days.current = "";
    security.current = "";
    upperBound.current = "";
    lowerBound.current = "";
    profitAlert.current = "";
    contracts.current = "";
    position.current = "Long";
    console.log("clearValues: Before update, data =", data); 
    
    //setData(clearedData);
    setData({
      ...data,
      days: "",
      security: "",
      upperBound: "",
      lowerBound: "",
      profitAlert: "",
      contracts: "",
      position: "Long" // Reset position in state to 'Long'
    });
    setSettingsStr(clearedData);

    console.log("clearValues: After update, data =", data); 
  }

  const canSuggest = data.position === "Short" && data.security && data.days;

  const handleChangeExpDate = (date) => {
    console.log ("Executing handleChangeExpDate");

    setSelectedExp(date);
    let expDays = countDays(date);
    console.log("handleChangeExpDate : expDays = " + expDays);

    if (date) {
      setData(prevData => ({ ...prevData, days: '' }));
      //setData({ ...data, days: expDays });
      days.current = expDays;
    }
  };

  const handleInputChange = (e) => {
    let name = null;
    let value = null;
    try {
      name = e.target.name;
      value = e.target.value;
    } catch (e) {}
    /*setData(prevData => ({
      ...prevData,
      [name]: value
    }));*/
  
    // Clear the expiration date if days are entered
    if (name === 'days' && value) {
      setSelectedExp(null);
    }
    
  };

  function countDays(expiration) {
    console.log("Executing countDays");

    const today = new Date();
  
    // Ensure all dates are compared at the start of the day for accuracy
    today.setHours(0, 0, 0, 0); 
  
    // Parse the expiration date string into a Date object
    console.log("countDays : received expiration = " + expiration);
    //const expirationDate = new Date(expiration);
    //const localDateTimeString = expiration + 'T00:00:00'; // Assume midnight
    const expirationDate = new Date(expiration);
    expirationDate.setHours(0, 0, 0, 0);

    console.log("countDays : expirationDate = " + expirationDate);
    console.log("countDays : today = " + today);

    console.log("countDays : expirationDate.getTime() = " + expirationDate.getTime());
    console.log("countDays : today.getTime() = " + today.getTime());
  
    const timeDifference = expirationDate.getTime() - today.getTime();
    const dayDifference = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));
    
    return dayDifference;
  }

  const isDaysDisabled = selectedExp !== null;
  const isDateDisabled = data.days !== '';

  // If icType is provided, show loading in AppLayout context
  if (icType) {
    return (
      <AppLayout signOut={undefined}>
        <div style={{ maxWidth: '1400px', margin: '0 auto', padding: '24px' }}>
          <div style={{ marginBottom: '24px' }}>
            <h1 style={{ fontSize: '28px', fontWeight: '700', color: 'rgba(0, 0, 0, 0.9)' }}>
              Generate Iron Condor Options
            </h1>
          </div>

          {/* Loading Message */}
          {!error && displayMessage && (
            <div className="blink_me" style={{
              marginBottom: '16px',
              textAlign: 'center',
              fontSize: '16px',
              padding: '16px',
              background: 'rgba(59, 130, 246, 0.1)',
              borderRadius: '8px'
            }}>
              {displayMessage}
            </div>
          )}

          {/* Error Message */}
          {error && (
            <div className="blink_me_red" style={{
              marginBottom: '16px',
              textAlign: 'center',
              fontSize: '16px',
              padding: '16px'
            }}>
              {error}
            </div>
          )}

          {/* Info Card showing parameters */}
          <div className="landing-panel">
            <div className="landing-panel-header">
              <h2 className="landing-panel-title">⚡ Quick Iron Condor - {icType}</h2>
            </div>
            <div className="landing-panel-content">
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                <div style={{ padding: '12px', background: 'rgba(249, 250, 251, 1)', borderRadius: '8px' }}>
                  <div style={{ fontWeight: '600', marginBottom: '8px', color: 'rgba(0, 0, 0, 0.8)' }}>Security:</div>
                  <div style={{ fontSize: '18px', fontWeight: '500' }}>{icType}</div>
                </div>
                <div style={{ padding: '12px', background: 'rgba(249, 250, 251, 1)', borderRadius: '8px' }}>
                  <div style={{ fontWeight: '600', marginBottom: '8px', color: 'rgba(0, 0, 0, 0.8)' }}>Position:</div>
                  <div style={{ fontSize: '18px', fontWeight: '500' }}>LONG</div>
                </div>
                <div style={{ padding: '12px', background: 'rgba(249, 250, 251, 1)', borderRadius: '8px' }}>
                  <div style={{ fontWeight: '600', marginBottom: '8px', color: 'rgba(0, 0, 0, 0.8)' }}>Days:</div>
                  <div style={{ fontSize: '18px', fontWeight: '500' }}>30</div>
                </div>
                <div style={{ padding: '12px', background: 'rgba(249, 250, 251, 1)', borderRadius: '8px' }}>
                  <div style={{ fontWeight: '600', marginBottom: '8px', color: 'rgba(0, 0, 0, 0.8)' }}>Contracts:</div>
                  <div style={{ fontSize: '18px', fontWeight: '500' }}>1</div>
                </div>
                <div style={{ padding: '12px', background: 'rgba(249, 250, 251, 1)', borderRadius: '8px' }}>
                  <div style={{ fontWeight: '600', marginBottom: '8px', color: 'rgba(0, 0, 0, 0.8)' }}>Upper Bound:</div>
                  <div style={{ fontSize: '18px', fontWeight: '500' }}>5%</div>
                </div>
                <div style={{ padding: '12px', background: 'rgba(249, 250, 251, 1)', borderRadius: '8px' }}>
                  <div style={{ fontWeight: '600', marginBottom: '8px', color: 'rgba(0, 0, 0, 0.8)' }}>Lower Bound:</div>
                  <div style={{ fontSize: '18px', fontWeight: '500' }}>0.1%</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </AppLayout>
    );
  }

  return (
    <AppLayout signOut={undefined}>
      <div style={{ maxWidth: '1400px', margin: '0 auto', padding: '24px' }}>
        <div style={{ marginBottom: '24px' }}>
          <h1 style={{ fontSize: '28px', fontWeight: '700', color: 'rgba(0, 0, 0, 0.9)' }}>
            Generate Iron Condor Options
          </h1>
        </div>

        {/* Loading and Error Messages */}
        {!error && displayMessage && (
          <div className="blink_me" style={{
            marginBottom: '16px',
            textAlign: 'center',
            fontSize: '16px',
            padding: '12px',
            background: 'rgba(59, 130, 246, 0.1)',
            borderRadius: '8px'
          }}>
            {displayMessage}
          </div>
        )}
        {error && (
          <div className="blink_me_red" style={{
            marginBottom: '16px',
            textAlign: 'center',
            fontSize: '16px',
            padding: '12px'
          }}>
            {error}
          </div>
        )}

        <div className="landing-panel">
          <div className="landing-panel-header">
            <h2 className="landing-panel-title">⚙️ Iron Condor Parameters</h2>
          </div>
          <div className="landing-panel-content">
            <form id="settingsForm" name="settingsForm" style={{ maxWidth: '800px', margin: '0 auto' }}>
              {/* Position */}
              <div style={{
                display: 'grid',
                gridTemplateColumns: '200px 1fr',
                gap: '16px',
                alignItems: 'center',
                marginBottom: '16px'
              }}>
                <label style={{ fontWeight: '600', color: 'rgba(0, 0, 0, 0.8)' }}>Position:</label>
                <select
                  name="position"
                  id="position"
                  value={data.position}
                  onChange={(e) => {
                    setData({ ...data, position: e.target.value });
                    position.current = e.target.value;
                  }}
                  style={{
                    padding: '8px 12px',
                    border: '1px solid rgba(209, 213, 219, 1)',
                    borderRadius: '6px',
                    fontSize: '14px'
                  }}
                >
                  <option value="Long">Long</option>
                  <option value="Short">Short</option>
                </select>
              </div>

              {/* Days or Expiration Date */}
              <div style={{
                display: 'grid',
                gridTemplateColumns: '200px 1fr 60px 1fr',
                gap: '16px',
                alignItems: 'center',
                marginBottom: '16px'
              }}>
                <label style={{ fontWeight: '600', color: 'rgba(0, 0, 0, 0.8)' }}>Days to Expiration:</label>
                <input
                  type="number"
                  id="days"
                  name="days"
                  ref={daysInputRef}
                  value={data.days || ''}
                  onChange={(e) => {
                    setData({ ...data, days: e.target.value });
                    days.current = e.target.value;
                    setError('');
                    handleInputChange();
                  }}
                  disabled={isDaysDisabled}
                  style={{
                    padding: '8px 12px',
                    border: '1px solid rgba(209, 213, 219, 1)',
                    borderRadius: '6px',
                    fontSize: '14px',
                    background: isDaysDisabled ? 'rgba(243, 244, 246, 1)' : 'white'
                  }}
                />
                <span style={{ textAlign: 'center', color: 'rgba(107, 114, 128, 1)', fontWeight: '500' }}>OR</span>
                <DatePicker
                  ref={dateInputRef}
                  selected={selectedExp}
                  onChange={handleChangeExpDate}
                  dateFormat="yyyy-MM-dd"
                  disabled={isDateDisabled}
                  style={{
                    padding: '8px 12px',
                    border: '1px solid rgba(209, 213, 219, 1)',
                    borderRadius: '6px',
                    fontSize: '14px',
                    background: isDateDisabled ? 'rgba(243, 244, 246, 1)' : 'white',
                    width: '100%'
                  }}
                />
              </div>

              {/* Security and Contracts */}
              <div style={{
                display: 'grid',
                gridTemplateColumns: '200px 1fr',
                gap: '16px',
                alignItems: 'center',
                marginBottom: '16px'
              }}>
                <label style={{ fontWeight: '600', color: 'rgba(0, 0, 0, 0.8)' }}>Security:</label>
                <input
                  type="text"
                  name="security"
                  value={data.security || ''}
                  onChange={(e) => {
                    setData({ ...data, security: e.target.value });
                    security.current = e.target.value;
                    setError('');
                  }}
                  style={{
                    padding: '8px 12px',
                    border: '1px solid rgba(209, 213, 219, 1)',
                    borderRadius: '6px',
                    fontSize: '14px'
                  }}
                />
              </div>

              <div style={{
                display: 'grid',
                gridTemplateColumns: '200px 1fr',
                gap: '16px',
                alignItems: 'center',
                marginBottom: '16px'
              }}>
                <label style={{ fontWeight: '600', color: 'rgba(0, 0, 0, 0.8)' }}>Number of Contracts:</label>
                <input
                  type="text"
                  name="contracts"
                  value={data.contracts || ''}
                  onChange={(e) => {
                    setData({ ...data, contracts: e.target.value });
                    contracts.current = e.target.value;
                    setError('');
                  }}
                  style={{
                    padding: '8px 12px',
                    border: '1px solid rgba(209, 213, 219, 1)',
                    borderRadius: '6px',
                    fontSize: '14px'
                  }}
                />
              </div>

              {/* Upper and Lower Bounds */}
              <div style={{
                display: 'grid',
                gridTemplateColumns: '200px 1fr',
                gap: '16px',
                alignItems: 'center',
                marginBottom: '16px'
              }}>
                <label style={{ fontWeight: '600', color: 'rgba(0, 0, 0, 0.8)' }}>Upper Bound %:</label>
                <input
                  type="number"
                  name="upperBound"
                  value={data.upperBound || ''}
                  onChange={(e) => {
                    setData({ ...data, upperBound: e.target.value });
                    upperBound.current = e.target.value;
                    setError('');
                  }}
                  style={{
                    padding: '8px 12px',
                    border: '1px solid rgba(209, 213, 219, 1)',
                    borderRadius: '6px',
                    fontSize: '14px'
                  }}
                />
              </div>

              <div style={{
                display: 'grid',
                gridTemplateColumns: '200px 1fr',
                gap: '16px',
                alignItems: 'center',
                marginBottom: '16px'
              }}>
                <label style={{ fontWeight: '600', color: 'rgba(0, 0, 0, 0.8)' }}>Lower Bound %:</label>
                <input
                  type="number"
                  name="lowerBound"
                  value={data.lowerBound || ''}
                  onChange={(e) => {
                    setData({ ...data, lowerBound: e.target.value });
                    lowerBound.current = e.target.value;
                    setError('');
                  }}
                  style={{
                    padding: '8px 12px',
                    border: '1px solid rgba(209, 213, 219, 1)',
                    borderRadius: '6px',
                    fontSize: '14px'
                  }}
                />
              </div>

              {/* Profit Alert */}
              <div style={{
                display: 'grid',
                gridTemplateColumns: '200px 1fr',
                gap: '16px',
                alignItems: 'center',
                marginBottom: '16px'
              }}>
                <label style={{ fontWeight: '600', color: 'rgba(0, 0, 0, 0.8)' }}>Profit Alert %:</label>
                <input
                  type="number"
                  name="profitAlert"
                  value={data.profitAlert || ''}
                  onChange={(e) => {
                    setData({ ...data, profitAlert: e.target.value });
                    profitAlert.current = e.target.value;
                    setError('');
                  }}
                  style={{
                    padding: '8px 12px',
                    border: '1px solid rgba(209, 213, 219, 1)',
                    borderRadius: '6px',
                    fontSize: '14px'
                  }}
                />
              </div>
            </form>

            <div style={{ display: 'flex', gap: '12px', justifyContent: 'center', marginTop: '24px' }}>
              <button
                onClick={() => { handleSuggest(); }}
                disabled={!canSuggest}
                title="To enable, select position short, enter days and security"
                style={{
                  padding: '12px 24px',
                  background: !canSuggest ? 'rgba(156, 163, 175, 1)' : 'linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  fontSize: '16px',
                  fontWeight: '600',
                  cursor: !canSuggest ? 'not-allowed' : 'pointer',
                  transition: 'all 0.2s',
                  opacity: !canSuggest ? 0.6 : 1
                }}
                onMouseEnter={(e) => {
                  if (canSuggest) {
                    e.currentTarget.style.transform = 'translateY(-2px)';
                    e.currentTarget.style.boxShadow = '0 4px 12px rgba(139, 92, 246, 0.4)';
                  }
                }}
                onMouseLeave={(e) => {
                  if (canSuggest) {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = 'none';
                  }
                }}
              >
                Suggest Safe Short Bounds
              </button>
            </div>

            <div style={{ display: 'flex', gap: '12px', justifyContent: 'center', marginTop: '12px' }}>
              <button
                onClick={() => { handleSubmit(); }}
                style={{
                  padding: '12px 32px',
                  background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  fontSize: '16px',
                  fontWeight: '600',
                  cursor: 'pointer',
                  transition: 'all 0.2s'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-2px)';
                  e.currentTarget.style.boxShadow = '0 4px 12px rgba(59, 130, 246, 0.4)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = 'none';
                }}
              >
                Submit
              </button>
              <button
                onClick={() => { clearValues(); }}
                style={{
                  padding: '12px 32px',
                  background: 'linear-gradient(135deg, #6b7280 0%, #4b5563 100%)',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  fontSize: '16px',
                  fontWeight: '600',
                  cursor: 'pointer',
                  transition: 'all 0.2s'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-2px)';
                  e.currentTarget.style.boxShadow = '0 4px 12px rgba(107, 114, 128, 0.4)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = 'none';
                }}
              >
                Clear
              </button>
            </div>
          </div>
        </div>
      </div>
    </AppLayout>
  );
}

export default GenerateOptionsLegs;